<page-toolbar [pageActions]="pageActions" [title]="title"></page-toolbar>

<page-content>

  <mat-card appearance="outlined" *ngIf="credentialObject">
    <div class="credentials">
      <p>{{credentialObject.loginName}}</p>
      <div [innerHTML]="credentialObject | json"></div>
    </div>
  </mat-card>

  <div class="spacer"></div>

  <mat-card appearance="outlined" *ngIf="!!boundProfile">
    <div *ngIf="boundProfile.email">Email: {{boundProfile.email}}</div>
    <button (click)="getEmail()" *ngIf="!boundProfile.email && boundProfile.userType === 'ibexfusion' && !create" class="ibexfusion-raised-button"
            mat-button>get email from credentials
    </button>
    <mat-form-field *ngIf="create">
      <input [(ngModel)]="boundProfile.email" matInput placeholder="email" type="email"/>
    </mat-form-field>

  </mat-card>

  <div class="spacer"></div>

  <mat-card appearance="outlined">
    <div class="form-container">
      <ng-template formHost></ng-template>
    </div>
    <div class="button-right-container">
      <button (click)="onSave()" class="ibexfusion-raised-button" mat-button>Save</button>
    </div>
  </mat-card>


</page-content>
